<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" class="p-button-danger" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-toast position="top-center no-print"></p-toast>
<div class="h-full hidden sm:hidden md:hidden lg:block">
  <div class="flex flex-wrap">
    <div class="w-6 p-4 surface-card">
      <img [src]="'assets/img/' +  baseImagePath + '/logo.png'" alt="Image" height="50">
      <div class="flex flex-wrap h-full justify-content-center align-content-center ">
          <div class="w-full h-full flex flex-wrap justify-content-center align-content-center pr-8 pl-8">
            <div class="text-900 text-3xl font-bold text-center">
              Benvenuto nel mondo {{worldName}}!
            </div>
            <div class="inputWidth block p-0">
              <label for="username" class="block text-900 font-medium mb-2 mt-4">
                Email
              </label>
              <input  id="username"
                      type="text"
                      pInputText
                      class="w-full"
                      [(ngModel)]="loginRequestModel.username">

              <label for="password" class="block mt-4 text-900 font-medium mb-2">
                Password
              </label>
              <input  id="password"
                      type="password"
                      pInputText
                      class="w-full"
                      [(ngModel)]="loginRequestModel.password">
            </div>
            <div class="w-full flex justify-content-center p-0">
              <div class="btnWidth justify-content-center block p-0">
                <button pButton pRipple label="Log in" icon="pi pi-user" class="p-button mt-4 w-full p-button-rounded" (click)="signIn()"></button>
              </div>
            </div>
            <div class="flex align-items-center justify-content-center mb-6 mt-5">
              <div class="flex align-items-center mr-5">
                <p-checkbox id="rememberme" [binary]="true" styleClass="mr-2" [(ngModel)]="loginRequestModel.remberMe"></p-checkbox>
                <label>Ricordami</label>
              </div>
              <a class="font-medium no-underline ml-5 text-blue-500 text-right cursor-pointer" (click)="forgotPassword()">Password dimenticata? </a>
            </div>
            <div class="w-full flex justify-content-center">
              <label class="text-center p-0 mt-1">Ancora non sei dei nostri? </label>
              <button pButton pRipple type="button" label="Registrati" class="p-button-text p-0 ml-1" (click)="goToRegistration()"></button>
            </div>
            <div class="w-full flex justify-content-center">
              <label class="text-center p-0 mt-1">Non hai ancora confermato le credenziali? </label>
              <button pButton pRipple type="button" label="Richiedi email di conferma" class="p-button-text p-0 ml-1" (click)="resendConfirmationEmail()"></button>
            </div>
          </div>
      </div>
    </div>
    <div class="h-full w-6 p-0 flex justify-content-end imageContainerDiv ">
      <img [src]="'assets/img/' +  baseImagePath + '/FotoLogin.png'" class="imgFoto">
    </div>
  </div>
</div>

<!-- LOGIN MOBILE -->

<div class="allScreen block sm:block md:block lg:hidden bg-primary-vertical">
  <div class="w-full h-full flex flex-wrap align-items-center justify-content-center imageManina px-4 py-8 md:px-6 lg:px-8">
    <div class="w-full mb-6">
      <img [src]="'assets/img/' +  baseImagePath + '/logo.png'" alt="Image" height="50">
    </div>
    <div class="p-6 text-center lg:w-30rem h-full w-full flex flex-wrap justify-content-center align-content-center">
      <div class="text-4xl font-medium mb-6 flex justify-content-center align-content-center">Benvenuto nel mondo Sapiens!</div>
      <input type="text" class="appearance-none border-none p-3 w-full outline-none text-xl block mb-4 bg-white-alpha-30" value="Email"
             style="border-radius: 30px"
             [(ngModel)]="loginRequestModel.username">
      <input type="password" class="appearance-none border-none p-3 w-full outline-none text-xl mb-4 bg-white-alpha-30" value="Password"
             style="border-radius: 30px"
             [(ngModel)]="loginRequestModel.password">
      <div class="flex align-items-center justify-content-center flex-wrap mb-6 mt-5">
        <div class="flex">
          <p-checkbox id="rememberme" [binary]="true" styleClass="mr-2" label="Ricordami" [(ngModel)]="loginRequestModel.remberMe"></p-checkbox>

          <a class="font-medium no-underline ml-5 text-blue-500 text-right cursor-pointer text-white" (click)="forgotPassword()">Password dimenticata?</a>
        </div>
      </div>
      <div class="p-0 w-full block">
        <button type="button" class="appearance-none border-none p-3 w-full outline-none text-xl mb-4 font-medium w-12rem" (click)="signIn()" style="border-radius: 30px">Log In</button>
        <div class="w-full flex justify-content-center flex-wrap">
          <label class="text-center p-0 mt-1">Ancora non sei dei nostri? </label>
          <button pButton pRipple type="button" label="Registrati" class="p-button-text p-0 ml-1 color-white font-bold" (click)="goToRegistration()"></button>
        </div>
        <div class="w-full flex justify-content-center">
          <label class="text-center p-0 mt-1">Non hai ancora confermato le credenziali? </label>
          <button pButton pRipple type="button" label="Richiedi email di conferma" class="p-button-text p-0 ml-1 color-white font-bold" (click)="resendConfirmationEmail()"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<p-dialog [header]="'Conferma OTP'" [(visible)]="showOtpDialog" [modal]="true"  [style]="{width: '20%'}"
          [draggable]="false" [resizable]="false">
  <app-otp-dialog (onVerifyOtp)="controlOtp($event)"
                  (onNewOtpRequest)="signIn()"></app-otp-dialog>

</p-dialog>

<p-dialog [header]="headerDetailsDialog" [(visible)]="showDetailsDialog" [modal]="true"
          [draggable]="false" [resizable]="false" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">

  <app-details [jobPostId]="jobPostSelected.IdCommessaAnnuncio" *ngIf="jobPostSelected.IdCommessaAnnuncio > 0"
               [showBtnCandidate]="true"
               >
  </app-details>
</p-dialog>
